'use client'

import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'

const Carousel3DInner = dynamic(
  () =>
    import('@/components/molecules/Carousel3D').then((mod) => mod.Carousel3D),
  {
    ssr: false,
    loading: () => <div className="carousel-3d carousel-3d--placeholder" />,
  },
)

export const Carousel3DWrapper = () => {
  const [shouldRender, setShouldRender] = useState(false)

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | undefined
    let idleCallbackId: number | undefined

    const scheduleRender = () => {
      setShouldRender(true)
    }

    if (typeof window.requestIdleCallback === 'function') {
      idleCallbackId = window.requestIdleCallback(scheduleRender, {
        timeout: 1500,
      })
    } else {
      timeoutId = setTimeout(scheduleRender, 1200)
    }

    return () => {
      if (typeof idleCallbackId === 'number') {
        window.cancelIdleCallback(idleCallbackId)
      }
      if (typeof timeoutId === 'number') {
        clearTimeout(timeoutId)
      }
    }
  }, [])

  if (!shouldRender) {
    return <div className="carousel-3d carousel-3d--placeholder" />
  }

  return <Carousel3DInner />
}
